/* Maqui - carrusel de fotos de la tarjeta de recomendados del carrito (6-sep-2026).
   El HTML de los recomendados se inyecta despues de cargar la pagina, asi que la
   logica va en un custom element: se conecta solo cuando el bloque entra al DOM. */
if (!customElements.get('maqui-upsell-gallery')) {
  class MaquiUpsellGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-maqui-track]');
      if (!this.track || this.dataset.maquiReady === 'true') return;
      this.dataset.maquiReady = 'true';
      this.shots = this.track.querySelectorAll('.maqui-upsell-shot');
      this.counter = this.querySelector('[data-maqui-count]');
      const prev = this.querySelector('[data-maqui-prev]');
      const next = this.querySelector('[data-maqui-next]');
      if (prev) prev.addEventListener('click', (e) => this.move(e, -1));
      if (next) next.addEventListener('click', (e) => this.move(e, 1));
      this.track.addEventListener('scroll', () => this.paint(), { passive: true });
      /* el carrusel del carrito no debe arrastrar la tarjeta entera */
      ['touchstart', 'pointerdown', 'mousedown'].forEach((evt) =>
        this.track.addEventListener(evt, (e) => e.stopPropagation(), { passive: true })
      );
    }

    get index() {
      if (!this.track.clientWidth) return 0;
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    move(event, step) {
      event.preventDefault();
      event.stopPropagation();
      const total = this.shots.length;
      const target = (this.index + step + total) % total;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
    }

    paint() {
      if (this.counter) this.counter.textContent = `${this.index + 1}/${this.shots.length}`;
    }
  }
  customElements.define('maqui-upsell-gallery', MaquiUpsellGallery);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Marca de medicion del carrito (9-sep-2026)

   Problema: cuando la prenda recomendada tiene varias tallas, el boton no agrega
   directo: abre el selector de tallas del tema, y ahi el que agrega es el
   formulario de Purity, no el nuestro. Sin esto solo quedarian marcadas las
   prendas de talla unica y el numero saldria corto.

   Solucion: al abrir el selector desde una tarjeta de recomendados se levanta una
   bandera; cuando el tema inyecta el contenido del selector, se le mete el campo
   oculto a los formularios de producto que traiga. La bandera se baja apenas se
   usa, y tambien si la clienta abre un selector desde cualquier otro lado.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  const ORIGEN = 'carrito-recomendados';
  const CAMPO = 'properties[_maqui_origen]';
  let pendiente = null;

  function marcarFormularios(raiz) {
    if (!pendiente || !raiz) return;
    const forms = raiz.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;
    forms.forEach((form) => {
      if (form.querySelector(`input[name="${CAMPO}"]`)) return;
      const campo = document.createElement('input');
      campo.type = 'hidden';
      campo.name = CAMPO;
      campo.value = pendiente;
      form.appendChild(campo);
    });
    pendiente = null;
  }

  /* Quien abrio el selector de tallas: una tarjeta del carrito, u otra cosa */
  document.addEventListener(
    'click',
    (event) => {
      const boton = event.target.closest('[is="button-quick-view"], .button-quick-view');
      if (!boton) return;
      pendiente = boton.dataset.maquiOrigen || null;
    },
    true
  );

  /* El tema reemplaza el contenido de .quickview-product al abrir el selector */
  function vigilar() {
    const caja = document.querySelector('.quickview-product');
    if (!caja) return false;
    new MutationObserver(() => marcarFormularios(caja)).observe(caja, {
      childList: true,
      subtree: true,
    });
    return true;
  }

  if (!vigilar()) {
    document.addEventListener('DOMContentLoaded', vigilar, { once: true });
  }
})();
